class SiteOverview
    extends QueryElement<HTMLElement> {
    
    private readonly _items: {[a: string]: SiteOverviewItem} = {};
    private readonly _site: Site;

    constructor(element: HTMLElement, site: Site) {
        super(element)

        this._site = site;
    }

    async register(container: SiteContainer) {
        let item = await SiteOverviewItem.create(this, this._site, container);
        this._items[container.getInstance() || ""] = item;

        this.append(item);

        let elem = this.get();
        if(elem !== null)
            elem.scrollTop = Number.MAX_SAFE_INTEGER;
    }
    removeItemByContainer(container:SiteContainer) {
        return this._items[container.getInstance() || ""].remove();
    }

    makeItemActiveByContainer(container: SiteContainer) {
        return this.makeItemActive(this._items[container.getInstance() || ""]);
    }
    makeItemInactiveByContainer(container: SiteContainer) {
        return this.makeItemInactive(this._items[container.getInstance() || ""]);
    }
    async makeItemInactive(item: SiteOverviewItem) {
        await item.makeInactive();
    }
    async makeItemActive(item: SiteOverviewItem) {
        if(!this.containsClass("active"))
            return;
        
        this.addClass("active-grow");
        await item.makeActive();
        this.removeClass("active-grow");
        this.makeInactive();
    }

    makeActive() {
        this.addClass("active");
    }
    makeInactive() {
        this.removeClass("active");
    }
}
class SiteOverviewItem
    extends QueryElement<HTMLElement> {

    private readonly _preview: QueryElement<HTMLElement>;
    
    private readonly _title: QueryElement<HTMLElement>;
    private readonly _container: SiteContainer;
    private readonly _overview: SiteOverview;
    private readonly _site: Site;
    private readonly _touch: QueryTouch;

    private _scale?: number;
    private _config = {
        maxWidth: 300,
        maxHeight: 300
    }

    public constructor(overview: SiteOverview, site: Site, container: SiteContainer) {
        super(document.createElement("DIV"))

        this.addClass("item");

        this._container = container;
        this._overview = overview;
        this._site = site;
        this._touch = new QueryTouch(this);
        this._preview = QueryElement.QueryElement("div")
            .addClass("preview");

        let recognizer = new QueryTouchSwipeRecognizer({
            direction: QueryTouchDirection.X,
            pointers: 1,
            threshold: 10,
            velocity: 0.2
        });
        recognizer.startEvent.on(async () => {
            this.addClass("drag");
        });
        recognizer.moveEvent.on(async (e) => {
            let style = this.style();
            if(style !== undefined)
                style.transform = `translate(${e.movedX}px, 0)`;
        });
        recognizer.stopEvent.on(async(a) => {
            if(a !== "none") {
                // Close received
                this._site.removeContainer(this._container);
            } else {
                // Slow mover, do not a thing :)
                this.removeClass("drag");
                let style = this.style();
                if(style !== undefined)
                    style.transform = `translate(0, 0)`;
            }
        });
        
        this._touch.addRecognizer(recognizer);

        let containerConfig = container.Config;

        this._title = QueryElement.QueryElement("DIV").addClass("title");
        if (containerConfig.color !== undefined) {
            this._title.setAttr("style", `background-color: ${containerConfig.color}`);
            this._preview.setAttr("style", `border-color: ${containerConfig.color}`)
        }
        if(containerConfig.icon !== undefined)
            this._title.append(QueryElement.QueryElement("I").setHtml(containerConfig.icon));
        if(containerConfig.title !== undefined)
            this._title.append(QueryElement.QueryElement("SPAN").setHtml(containerConfig.title));
        
        let closeButton = new SiteButton({
            icon: "close"
        }, true);
        closeButton.on("click", (e) => {
            site.removeContainer(container);
            e.stop();
        });
        this._title.append(closeButton);

        this.on("click", async () => {
            await this._site.makeContainerActive(this._container);
        });

        container.on("qts.active", () => {
            this.addClass("container-active");
        });
        container.on("qts.inactive", () => {
            this.removeClass("container-active");
        });
        container.on("qts.loading", () => {
            this.addClass("container-loading");
        });
        container.on("qts.loaded", () => {
            this.removeClass("container-loading");
        });

        this.append(this._title);
        this.append(this._preview);
    }
    
    static async create(overview: SiteOverview, site: Site, container: SiteContainer) {
        return await new SiteOverviewItem(overview, site, container);
    }

    async makeActive() {
        
    }
    async makeInactive() {
        this._preview.setHtml("");

        for (let title of this._container.getCards().all<SiteCard, string>(a => a.Title)) {
            QueryElement.QueryElement("div")
                .setHtml(title)
                .appendTo(this._preview);
        }
    }
    async remove(removeInner = true) {
        await super.remove(removeInner);
    }

}